// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ozWGf1uh8YFld4JHuFLC{height:100%;position:relative}.ozWGf1uh8YFld4JHuFLC.IwOV3q84UQ8rA2DQ5mNG{z-index:var(--zIndex-BASE_12);position:absolute}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ozWGf1uh8YFld4JHuFLC`,
	"mobileView": `IwOV3q84UQ8rA2DQ5mNG`
};
export default ___CSS_LOADER_EXPORT___;
